import { createSelector } from 'reselect';

import { getState as getParent, getRoot, getDefaultQuestionId, getByIds } from 'modules/questionModels/selectors';
import { getSelectedDealerId } from 'selectors/dealerSelectors';
import { uniq } from 'utils/ObjectUtils';

const getProps = (_, props) => props;

const getState = createSelector(getParent, state => state.ui.configSelect);

export const hasMore = createSelector(getState, config => config.hasMore);
export const getPage = createSelector(getState, config => config.page);
const getIds = createSelector(getState, config => config.ids);
export const isLoading = createSelector(getState, config => config.loading);
export const getError = createSelector(getState, config => config.error);

const getDataSourceIds = createSelector(getIds, getDefaultQuestionId, getProps, (ids, questionId, selectedId) =>
  uniq([...(questionId ? [questionId] : []), selectedId, ...ids]));

export const getList = createSelector(getRoot, getDataSourceIds, getByIds);

export const getParams = createSelector(getPage, getSelectedDealerId, (page, dealerId) => ({
  status: 'OPEN',
  dealerId,
  page: page.number ?? 0,
  size: page.size ?? 20,
  sort: ['dealerId,desc', 'groupId,desc', 'name,asc'],
}));
